export default __webpack_public_path__ + "static/penthouses-apartments-a5ebd149a2abd3d4aa70cd9b128b4954.png";